import { type LabelPreferenceId } from "owa-mail-ribbon-store-shared-types/lib/util/labelPreferencesIds";
import { type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import type RibbonCustomizerStore from "./schema/ribbonCustomizerStore";
import { createStore } from "owa-satcheljs";
import type { MailboxInfo } from "owa-client-types";
import { getAnonymousMailboxInfo } from "owa-mailbox-info/lib/getAnonymousMailboxInfo";

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getAnonymousMailboxInfo called at module scope is not allowed. This may cause unwanted side effects. */
const defaultMailboxInfo: MailboxInfo = getAnonymousMailboxInfo();

/**
 * Store for the Ribbon Customizer. This essentially is a temporary holder for all the changes
 * that a user is making for a single tab. When a user clicks save, that's when we transfer the changes
 * over to owa-mail-ribbon-store to reflect the new ribbon.
 */
const defaultRibbonCustomizerStore: RibbonCustomizerStore = {
    layout: [],
    controlsInOverflow: [],
    staticGroupIdOrdering: [],
    showLabelsPreference: 1,
    dragControl: null,
    editingGroupName: null,
    dragGroup: null,
    isCustomizing: false,
    preDragLayout: null,
    selectedTab: 1,
    mailboxInfo: defaultMailboxInfo,
};

export const getStore: () => RibbonCustomizerStore = createStore<RibbonCustomizerStore>("RibbonCustomizer", defaultRibbonCustomizerStore);
export default getStore;
